import { getEventStartEndUtc } from "./timezoneFormatter";

const parseLocalEventDateTime = (dateValue, timeValue, fallbackTime = "00:00:00") => {
  if (!dateValue) return null;

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return null;

  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  const [hours = 0, minutes = 0, seconds = 0] = String(
    timeValue || fallbackTime,
  )
    .split(":")
    .map((value) => parseInt(value, 10) || 0);

  return new Date(year, month, day, hours, minutes, seconds);
};

export const getEventTimingStatus = (eventData, now = new Date()) => {
  const { startUtc, endUtc } = getEventStartEndUtc(eventData);

  const start = startUtc || parseLocalEventDateTime(
    eventData?.start_date,
    eventData?.start_time,
    "00:00:00",
  );
  const end = endUtc || parseLocalEventDateTime(
    eventData?.end_date || eventData?.start_date,
    eventData?.end_time,
    "23:59:59",
  );

  if (end && now.getTime() >= end.getTime()) {
    return { status: "ended", start, end, isUpcoming: false, isLive: false, isEnded: true };
  }

  if (start && now.getTime() < start.getTime()) {
    return { status: "upcoming", start, end, isUpcoming: true, isLive: false, isEnded: false };
  }

  return { status: "live", start, end, isUpcoming: false, isLive: true, isEnded: false };
};

export const getDaysToEventLabel = (eventData, fallbackDaysGap) => {
  const timing = getEventTimingStatus(eventData);

  if (timing.isEnded) return "Event ended";
  if (timing.isLive) {
    if (!timing.start) return "Day 1";
    const dayMs = 1000 * 60 * 60 * 24;
    const currentDay = Math.floor((Date.now() - timing.start.getTime()) / dayMs) + 1;
    return `Day ${Math.max(1, currentDay)}`;
  }

  if (fallbackDaysGap !== undefined && !Number.isNaN(fallbackDaysGap)) {
    return fallbackDaysGap;
  }

  if (!timing.start) return "Event started";

  const diff = timing.start.getTime() - Date.now();
  const gap = Math.ceil(diff / (1000 * 60 * 60 * 24));
  return !Number.isNaN(gap) ? gap : "Event started";
};
